import { render, staticRenderFns } from "./KolMapperList.vue?vue&type=template&id=07c58e6b&scoped=true"
import script from "./KolMapperList.vue?vue&type=script&lang=js"
export * from "./KolMapperList.vue?vue&type=script&lang=js"
import style0 from "./KolMapperList.vue?vue&type=style&index=0&id=07c58e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c58e6b",
  null
  
)

export default component.exports